import {
  MESSAGE_DATA_DOWNLOAD, MESSAGE_DATA_DOWNLOAD_FAILURE, MESSAGE_DATA_DOWNLOAD_SUCCESS
} from './mutation-types'

export default {
  state: {
    messageManagers: [],
    messageOfficers: [],
    messageHarassments: []
  },
  getters: {
    messageManagers: state => {
      return state.messageManagers
    },
    messageOfficers: state => {
      return state.messageOfficers
    },
    messageHarassments: state => {
      return state.messageHarassments
    }
  },
  actions: {
    [MESSAGE_DATA_DOWNLOAD] ({dispatch, state, commit}, params = null) {
      console.log('MESSAGE_DATA_DOWNLOAD')
      var callback = () => {}
      var data = {}
      if (params) {
        data = params.data
        callback = params.callback
      }
      dispatch('apiGet', { url: '/master/messages/data_download', data: data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MESSAGE_DATA_DOWNLOAD_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MESSAGE_DATA_DOWNLOAD_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [MESSAGE_DATA_DOWNLOAD_FAILURE] (state, data) {
      console.log('MESSAGE_DATA_DOWNLOAD_FAILURE')
    },
    [MESSAGE_DATA_DOWNLOAD_SUCCESS] (state, data) {
      console.log('MESSAGE_DATA_DOWNLOAD_SUCCESS')
      if (data.data.message_managers) {
        state.messageManagers = data.data.message_managers.data
      }
      if (data.data.message_officers) {
        state.messageOfficers = data.data.message_officers.data
      }
      if (data.data.message_harassments) {
        state.messageHarassments = data.data.message_harassments.data
      }
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/message.js